/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Promised Prepayment Reducers
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import produce from 'immer';

import {
    PROMISED_PAYMENT_GET_AMOUNT_ACTION,
    PROMISED_PAYMENT_GET_AMOUNT_FAILURE,
    PROMISED_PAYMENT_GET_AMOUNT_SUCCESS,
    PROMISED_PAYMENT_SUBMIT_ACTION,
    PROMISED_PAYMENT_SUBMIT_FAILURE,
    PROMISED_PAYMENT_SUBMIT_SUCCESS,
} from './promisedPaymentConstants';
import { TPromisedPaymentActions } from './promisedPaymentTypes';

export interface IPromisedPaymentState {
    amount: number;
    error: string;
    loading: boolean;
    validity: string;
}

export const promisedPaymentState: IPromisedPaymentState = {
    amount: 0,
    error: '',
    loading: false,
    validity: '',
};

const promisedPaymentReducer = (state: IPromisedPaymentState = promisedPaymentState, action: TPromisedPaymentActions) =>
    produce(state, (draft) => {
        switch (action.type) {
            case PROMISED_PAYMENT_GET_AMOUNT_ACTION:
                draft.error = '';
                draft.loading = true;
                break;
            case PROMISED_PAYMENT_GET_AMOUNT_SUCCESS:
                draft.amount = action.payload.amount;
                draft.validity = action.payload.validity;
                draft.loading = false;
                break;
            case PROMISED_PAYMENT_GET_AMOUNT_FAILURE:
                draft.error = action.payload.message;
                draft.loading = false;
                break;

            case PROMISED_PAYMENT_SUBMIT_ACTION:
                draft.error = '';
                draft.loading = true;
                break;
            case PROMISED_PAYMENT_SUBMIT_SUCCESS:
                draft.amount = action.payload.amount;
                draft.validity = action.payload.validity;
                draft.loading = false;
                break;
            case PROMISED_PAYMENT_SUBMIT_FAILURE:
                draft.error = action.payload.message;
                draft.loading = false;
                break;

            default:
                break;
        }
    });

export default promisedPaymentReducer;
